import {Component, Input} from '@angular/core';

@Component({
  selector: 'ccc-cca-loading-spinner',
  styleUrls: ['./loading-spinner.component.scss'],
  templateUrl: './loading-spinner.component.html'
})
export class LoadingSpinnerComponent {
  @Input() show: boolean;
}
